import { EventrDate } from '@eventr/common'
import { ColoursObj, Icon, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { cardTranslation } from '../../../i18n/translateHelpers'
import { CardText } from '../../componentCards/subComponents/cardText'
import { RowInfo } from '../../componentCards/subComponents/rowInfo'
import { RowInfoFiles } from '../../componentCards/subComponents/rowInfoFiles'
import { RowInfoNotes } from '../../componentCards/subComponents/rowInfoNotes'
import { useFormatValue } from '../../hooks/useFormatValue'
interface IFlightDetailsProps {
    flightStatus?: string
    booking_ref?: string
    baggage_allowance?: string
    notes?: string
    personalFiles?: string[]
    checkInDesk?: string
    gate?: string
    revisedTime?: string
    departureTime?: string
}
export const FlightDetails = ({
    flightStatus,
    booking_ref,
    baggage_allowance,
    notes,
    personalFiles,
    checkInDesk,
    gate,
    revisedTime,
    departureTime,
}: IFlightDetailsProps) => {
    const { formatValue } = useFormatValue()
    const delayTime = useMemo(() => {
        if (revisedTime) {
            const eDepartureTime = new EventrDate(departureTime)

            const eRevisedTime = new EventrDate(revisedTime.replace(' ', 'T'))
            if (eDepartureTime?.timezoneNumber !== undefined) {
                eRevisedTime.setTimezoneEnum(eDepartureTime.timezoneNumber)
            }

            if (eRevisedTime.getUnixMs > eDepartureTime.getUnixMs)
                return eRevisedTime
        }
        return null
    }, [departureTime, revisedTime])
    return (
        <Stack paddingTop="8px" gap={'8px'}>
            {delayTime && (
                <RowInfo
                    start={
                        <Icon
                            name={'Info'}
                            iconColour={ColoursObj.states.error}
                        />
                    }
                    under={
                        <CardText>
                            {formatValue(delayTime.dateTimeString, 'time')}
                        </CardText>
                    }
                    middle={
                        <Typography variant="bodyBold">
                            {cardTranslation('Departure Delay')}
                        </Typography>
                    }
                />
            )}
            {flightStatus && (
                <RowInfo
                    start={
                        <Icon
                            name={'Schedule'}
                            iconColour={ColoursObj.core.secondary}
                        />
                    }
                    under={<CardText>{flightStatus}</CardText>}
                    middle={
                        <Typography variant="bodyBold">
                            {cardTranslation('Flight Status')}
                        </Typography>
                    }
                />
            )}
            {booking_ref && (
                <RowInfo
                    start={
                        <Icon
                            name={'Flight_Booking'}
                            iconColour={ColoursObj.coreBrights.tertiary}
                        />
                    }
                    under={<CardText>{booking_ref}</CardText>}
                    middle={
                        <Typography variant="bodyBold">
                            {cardTranslation('Booking Reference')}
                        </Typography>
                    }
                />
            )}
            {gate && (
                <RowInfo
                    start={
                        <Icon
                            name={'Depart'}
                            iconColour={ColoursObj.coreBrights.secondary}
                        />
                    }
                    under={<CardText>{gate}</CardText>}
                    middle={
                        <Typography variant="bodyBold">
                            {cardTranslation('Gate')}
                        </Typography>
                    }
                />
            )}
            {checkInDesk && (
                <RowInfo
                    start={
                        <Icon
                            name={'Dashboard'}
                            iconColour={ColoursObj.coreBrights.tertiary}
                        />
                    }
                    under={<CardText>{checkInDesk}</CardText>}
                    middle={
                        <Typography variant="bodyBold">
                            {cardTranslation('Check-in Desk')}
                        </Typography>
                    }
                />
            )}
            {baggage_allowance && (
                <RowInfo
                    start={
                        <Icon
                            name={'Suitcase'}
                            iconColour={ColoursObj.coreBrights.secondary}
                        />
                    }
                    under={<CardText>{baggage_allowance}</CardText>}
                    middle={
                        <Typography variant="bodyBold">
                            {cardTranslation('Baggage Allowance')}
                        </Typography>
                    }
                />
            )}
            {notes && <RowInfoNotes type="page" notes={notes} />}
            {personalFiles && personalFiles.length > 0 && (
                <RowInfoFiles type="page" files={personalFiles} />
            )}
        </Stack>
    )
}
